<template>
  <div class="card-table-container">
    <div style="min-width: 277px;">
      <div class="card-table-header flex height-31 home_m_table">
        <div class="flex-1" v-for="i in tableHead">{{ i }}</div>
      </div>
      <ul class="card-table-body">
        <li class="flex height-31 home_m_table" v-for="v in sharedStockRows(list, 'cn')" @click="childMethod(v.code)" :key="v.code">
          <div class="flex-1">{{ v.code }}</div>
          <div class="flex-1">{{ v.name }}</div>
          <div v-if="classify" class="flex-1" >{{ percent(v.zf) }}</div>
          <div v-if="classify" :class="changeClass(v.zdf)" >{{ percent(v.zdf) }}</div>
          <div v-if="!classify" :class="changeClass(v.zdf)" >{{ percent(v.zdf) }}</div>
          <div v-if="!classify" class="flex-1" >{{ percent(v.hsl) }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { quotePercent } from '@/utils/quoteDisplay'
import { sharedStockRows } from '@/utils/stockQuoteFeed'
import { quoteTone } from '@/utils/quoteColors'
export default {
  name: "DayTable",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    tableHead: {
      type: Array,
      default: () => []
    },
    classify: {
      type: Boolean,
      default:()=>true
    }
  },
  methods: {
    sharedStockRows,
    percent: quotePercent,
    childMethod(code) {
      this.$nextTick(() => {
        this.$emit('code-click', code)
      });
      
    },
    changeClass(idx){
      return 'flex-1 ' + quoteTone(idx)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-table-container {
  height: 100%;
  overflow: auto;
  color: var(--theme-label);
  cursor: pointer;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #eee;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 8px;

    &:hover {
      background-color: #a8a8a8;
    }

    &:active {
      background-color: #787878;
    }
  }

  & {
    border-radius: 8px;
    scrollbar-width: thin;
    scrollbar-color: #c1c1c1 #eee;
  }
}

.height-31 {
  height: 31px;
  line-height: 31px;
}

.card-table-header,.card-table-body {
  padding: 0 11px;
}
.card-table-body {
  overflow-y: auto;
}
.home_m_table > div{
  overflow: hidden;text-overflow: ellipsis;white-space: nowrap;
}
</style>
